module.exports = __webpack_public_path__ + "img/DSCN0281.adb0179a.jpg";